module.exports = __webpack_public_path__ + "static/media/utvr.41506f18.png";